import Repository from '../../repositories/RepositoryFactory';

const TerraRepository = Repository.get('terra');

export default {
	namespaced: true,
	state: {
		terraUserMapping: [],
		ecpUsers: [],
	},
	mutations: {
		SET_TERRA_USER_MAPPING (state, mapping) {
			state.terraUserMapping = mapping;
		},
		SET_ECP_USERS (state, users) {
			state.ecpUsers = users;
		},
	},
	actions: {
		async getDataFrom3rdParty ({ commit }, data) {
			return await TerraRepository.getDataFrom3rdParty(data.patientId);
		},
		async eventHandler ({ commit }) {
			return await TerraRepository.eventHandler();
		},
		async getTerraUserMappingTable ({ commit }, locationId) {
			commit('SET_TERRA_USER_MAPPING', await TerraRepository.getTerraUserMappingTable(locationId));
		},
		async getECPUsersForTerraMappings ({ commit }) {
			const response = await TerraRepository.getECPUsersForTerraMappings();
			response.forEach((location) => location.ecpUserForTerraDto.unshift({ userName: 'None/Mixed', id: 0 }));
			commit('SET_ECP_USERS', response);
		},
		async setSendingDataFromTerraToECP ({ commit }, body) {
			return await TerraRepository.setSendingDataFromTerraToECP(body);
		},
		async setECPUserInpersonateId ({ commit }, body) {
			return await TerraRepository.setECPUserInpersonateId(body);
		},
	},
	getters: {},
};
